import React, { Component } from 'react';
import Chart from './EnergyFlow';



function EnergyFlow({ position, changePosition, isMobile }) {
            
    return <Chart position={position}
                  changePosition={changePosition}
                  isMobile={isMobile}/>        
  
}

export default EnergyFlow;